<template>
  <v-img 
    v-if="icon"
    :key="icon"
    class="icon" 
    :src="icon"
    :style="{ 
      margin: margin,
      height: height,
      width: width
    }"
  />
</template>
<script>
export default {
  props: {
    image: {
      type: String,
      required: true,
    },
    margin: {
      type: String,
      required: true,
    },
    height: {
      type: String,
      required: true,
    },
    width: {
      type: String,
      required: true,
    },
  },
  data: () => ({
    icon: null,
  }),
  watch: {
    image () {
      this.icon = null
      this.icon = this.image
    },
  },
  mounted () {
    this.icon = null
    this.icon = this.image
  },
}
</script>

